namespace SPA
{
	export namespace LRM /* land_region_map */
	{

		export class List
			extends ui.tab.TabHTMLPresentation
		{

			private	m_List: 		SPA.gui.Listing<Wollmilch.LandMapRegion.ILRMObject>;
			private	m_Data:			Wollmilch.LandMapRegion.ILRMObject[][];
			private	m_ListBox:	ui.Box.Box;
			private	m_Parent:		JQuery|null;
			private	m_Count:		number;
			private	m_Page:			number;

			public constructor()
			{
				super( 'div' );

				this.m_Data			= new Array<Wollmilch.LandMapRegion.ILRMObject[]>();
				this.m_Count		= 0;
				this.m_Page			= 0;
				this.m_ListBox	= new ui.Box.Box();
				this.m_Parent		= null;

				this.m_List			=  new SPA.gui.Listing<Wollmilch.LandMapRegion.ILRMObject>(
					new LRMTableModel(),
					10,
					( list: SPA.gui.Listing<Wollmilch.LandMapRegion.ILRMObject>, count: number, page: number ): void =>
					{
						count = clamp( count, 5, 50 );

						const idx = this.m_Data.findIndex( ( value, index ) => index === page && value !== undefined );

						if ( idx > -1 )
						{
							list.Content().Data( this.m_Data[ idx ] );
							list.Content().rebuild();

							return;
						}

						new Wollmilch.AJAX(
							{
								url: 'object/list/' + app.getAuthenticationManager().getPerson() + '/limit/' + count + '/page/' + page,
								on:
								{
									success: ( text: string ): void =>
									{
										let obj: Wollmilch.ResponseObject|null;

										try
										{
											obj = Wollmilch.jsonize( text );
										}
										catch ( e )
										{
											app.addNotify(
												{
													title: [ ui.h( 3, app.getMessage( 'Realtor.List.ERROR_LIST' ) ) ],
													body: [ ui.text( app.getMessage( 'Realtor.List.ERROR_LIST_TEXT' ) ) ],
													context: 'warning',
													timeout: Number(app.getConfigValue("ToastTimeout"))
												}
											);

											return;
										}

										if ( !obj || !obj.success )
										{
											app.addNotify(
												{
													title: [ ui.h( 3, app.getMessage( 'Realtor.List.ERROR_LIST' ) ) ],
													body: [ ui.text( app.getMessage( 'Realtor.List.ERROR_LIST_TEXT' ) ) ],
													context: 'info',
													timeout: Number(app.getConfigValue("ToastTimeout"))
												}
											);

											return;
										}

										list.Content().Data( obj.data );
										list.Content().rebuild();

										this.m_Count	= obj.count;
										this.m_Page		= page;

										list.SetPage( this.m_Page, this.m_Count );

										this.m_Data[ page ] = obj.data;
									}
								}
							},
							Wollmilch.AJAXCallbase_e.LRM
						).send();
					}
				);

				this.Initialize({});
			}

			public reload(): void
			{
				if ( this.m_Entry )
				{
					this.m_Entry.ActivateReloadSpin();
				}

				this.m_Data	= new Array();

				this.m_ListBox.empty();

				this.m_List.reload( this.m_ListBox );

				if ( this.m_Entry )
				{
					this.m_Entry.DeactivateReloadSpin();
				}
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): List
			{
				if ( !this.m_Parent ) { this.m_Parent	= root instanceof ui.base.BaseHTMLElement ? root.Root() : root; }

				super.rebuild( root );

				this.empty();

				this.m_ListBox.appendTo( this );

				this.m_List.rebuild( this.m_ListBox );

				if ( this.m_Entry )
				{
					this.m_Entry.DeactivateReloadSpin();
				}

				return this;
			}

		}

	}
}
